import { Globe } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';

export const LanguageToggle = () => {
    const { language, switchLanguage } = useLanguage();

    return (
        <button
            onClick={() => switchLanguage(language === 'en' ? 'he' : 'en')}
            className="flex items-center gap-2 px-4 py-2 rounded-lg glass hover-lift text-sm font-medium"
            aria-label="Toggle language"
        >
            <Globe className="w-4 h-4" />
            <span>{language === 'en' ? 'עברית' : 'English'}</span>
        </button>
    );
};
